import script from "./EmailSettingAccountSynced.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSettingAccountSynced.vue?vue&type=script&setup=true&lang=ts"

import "./EmailSettingAccountSynced.vue?vue&type=style&index=0&id=c2b59cd8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b59cd8"]])

export default __exports__